export default __webpack_public_path__ + "static/media/katilyn.8cb58961.jpg";